import { ArrowUpRight, Clock3 } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatDateTime } from "@/lib/format";
import type { RecentSearchRecord } from "@/lib/recent-searches";

interface RecentSearchListProps {
  searches: RecentSearchRecord[];
  onOpen: (searchId: string) => void;
}

export function RecentSearchList({ searches, onOpen }: RecentSearchListProps) {
  if (!searches.length) {
    return null;
  }

  return (
    <Card className="bg-background/40">
      <CardHeader>
        <CardTitle className="text-base font-medium">Recent searches</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {searches.map(search => (
          <button
            key={search.searchId}
            type="button"
            className="draft-box flex w-full items-center justify-between gap-4 px-4 py-3 text-left transition-colors hover:bg-muted/20"
            onClick={() => onOpen(search.searchId)}
          >
            <div className="min-w-0 space-y-1">
              <p className="truncate text-sm font-medium text-foreground">{search.queryTitle ?? search.query}</p>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Clock3 className="size-3.5" />
                <span>{formatDateTime(search.completedAt ?? search.createdAt)}</span>
              </div>
            </div>
            <span className="shrink-0 text-muted-foreground">
              <ArrowUpRight className="size-4" />
            </span>
          </button>
        ))}
      </CardContent>
    </Card>
  );
}
